import { useRef } from "react";
import { toast } from "sonner";
import { toCsv, parseCsv, download } from "@/lib/csv";
import { RuleNum } from "@/components/deck/RuleNum";

const COLS = ["name", "ic", "bonus", "groups"];

export const SetsRules = ({ rules, update }) => {
  const file = useRef(null);
  const sets = rules.sets;
  const groupKeys = Object.keys(rules.groups);
  const setRow = (i, patch) => update({ sets: sets.map((s, j) => (j === i ? { ...s, ...patch } : s)) });
  const toggleGroup = (i, g) => {
    const cur = sets[i].groups || [];
    setRow(i, { groups: cur.includes(g) ? cur.filter((x) => x !== g) : [...cur, g] });
  };
  const exportCsv = () => download("gear-sets.csv", toCsv(COLS, sets.map((s) => ({ ...s, groups: (s.groups || []).join("|") }))));
  const importCsv = async (f) => {
    const rows = parseCsv(await f.text());
    if (!rows.length || !("name" in rows[0])) { toast.error("The CSV needs a 'name' column"); return; }
    update({ sets: rows.map((r) => ({ name: r.name, ic: Number(r.ic) || 0, bonus: r.bonus || "", groups: (r.groups || "").split("|").map((x) => x.trim()).filter((x) => groupKeys.includes(x)) })) });
    toast.success(`Loaded ${rows.length} sets. Press Save rules to keep them.`);
  };
  return (
    <div data-testid="rules-sets">
      <p style={{ fontSize: 13, marginBottom: 8 }}>A set bonus counts only when all 3 pieces are the same set. "IC" is the set's Initial Charge bonus in seconds (Noble −1, Enchantress −1). Tick the groups a set suits in Historic & Tesla.</p>
      <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
        <button className="lg-btn ghost sm" onClick={() => update({ sets: [...sets, { name: "New set", ic: 0, bonus: "", groups: [] }] })} data-testid="sets-add">+ Add set</button>
        <button className="lg-btn ghost sm" onClick={exportCsv} data-testid="sets-export">Export CSV</button>
        <button className="lg-btn ghost sm" onClick={() => file.current.click()} data-testid="sets-import">Import CSV</button>
        <input ref={file} type="file" accept=".csv,text/csv" hidden onChange={(e) => { if (e.target.files[0]) importCsv(e.target.files[0]); e.target.value = ""; }} />
      </div>
      <div className="lg-scroll">
        <table className="lg-itable">
          <thead><tr><th>Set</th><th>IC (s)</th><th>Bonus text</th><th>Good for (Historic & Tesla)</th><th></th></tr></thead>
          <tbody>{sets.map((s, i) => (
            <tr key={i} data-testid={`set-row-${i}`}>
              <td><input className="lg-input lg-mini" value={s.name} onChange={(e) => setRow(i, { name: e.target.value })} data-testid={`set-name-${i}`} /></td>
              <td><RuleNum value={s.ic ?? 0} onChange={(v) => setRow(i, { ic: v })} testid={`set-ic-${i}`} w={60} /></td>
              <td><input className="lg-input lg-mini" style={{ minWidth: 200 }} value={s.bonus || ""} onChange={(e) => setRow(i, { bonus: e.target.value })} data-testid={`set-bonus-${i}`} /></td>
              <td><div className="lg-chips">{groupKeys.map((g) => (
                <button key={g} type="button" className={`lg-chip ${(s.groups || []).includes(g) ? "on" : ""}`} style={{ padding: "3px 9px", fontSize: 11 }} onClick={() => toggleGroup(i, g)} data-testid={`set-group-${i}-${g}`}>{g}</button>
              ))}</div></td>
              <td><button className="lg-btn danger sm" onClick={() => update({ sets: sets.filter((_, j) => j !== i) })} data-testid={`set-del-${i}`}>✕</button></td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
};
